<ng-container *ngIf="errorsCombined$ | async as errorsCombined">
	<ul class="errors" *ngIf="errorsCombined.length > 0">
		<li *ngFor="let error of errorsCombined" [title]="error.code">{{ error.message }}</li>
	</ul>
</ng-container>
